export const SpreadsheetAnalysisUsageConsent = {
    PENDING: 'PENDING',
    ACKNOWLEDGED: 'ACKNOWLEDGED'
};
